module.exports = __webpack_public_path__ + "assets/img/5-1.ea849427.jpg";